import { useCallback, useState } from "react";
import { useSetRecoilState } from "recoil";

import { useNetwork } from "hooks";
import { IsTokenState } from "./state";
import { API_URL } from "constant";

export const useUserVerification = () => {
  const setQrDetails = useSetRecoilState(IsTokenState)
  const params = new URLSearchParams(window.location.search);
  const qrId = params.get("code");
  const [mobileLinkOnDevice, setMobileLinkOnDevice] = useState({
    loaded: true,
    data: [],
    error: false,
  });
  const {
    post,
    get,
    data: loginApiData,
    statusCode,
  } = useNetwork({ updateState: false });

  const { patch } = useNetwork();

  const fetchCodesForVerification = useCallback(
    (code: string, hostType?: string) => {
      setMobileLinkOnDevice((prev) => ({ ...prev, loaded: false }));
      get(`${API_URL.USER_LOGIN}/${code}`, hostType).then((resp) => {
        if (resp) {
          const { securityCodes } = resp.data ?? {};
          if (securityCodes) {
            setMobileLinkOnDevice((prev) => ({
              ...prev,
              loaded: true,
              data: securityCodes,
            }));
            return;
          }
          setMobileLinkOnDevice((prev) => ({
            ...prev,
            error: true,
            loaded: true,
          }));
          return;
        }
        setMobileLinkOnDevice((prev) => ({ ...prev, loaded: true }));
      });
    },
    [get, setMobileLinkOnDevice]
  );

  const selectOptionFromMobile = useCallback(
    async (payload: any, hostType?: string): Promise<boolean> => {
      const resp = await post(API_URL.USER_LOGIN, payload, hostType);
      if (resp) {
        const { status } = resp;
        if (status === "approved") {
          return true;
        }
        return false;
      }
      return false;
    },
    [post]
  );

  const handleAuthUser = async (key: string, authId: string) => {
    const status = key === "accept" ? "APPROVED" : "REJECTED";
    try {
      const response = await patch(
        `${API_URL.AUTH_APPROVAL}/${authId}`,
        { status: status },
        "auth"
      );

      if (response) {
        const { status } = response;
        if (status?.toLowerCase() === "approved") {
          return true;
        }
        return false;
      }
      return false;
    } catch (err: any) {
      return false;
    }
  };
  const handleVerifyEmail = async (key: string,code:string,verificationId:string) => {
    const status = key === "accept" ? "APPROVED" : "REJECTED";
    const payload = {
      code:code,
      payload: {
        id:verificationId,
        approvedStatus:status.toLowerCase()
    },
    type:"update-email-verification"
    }
    try {
      const response: any = await post(
        `${API_URL.EMAIL_VERIFICATION}`,{...payload},'emailVerification');
      if (response) {
        const { approvedStatus } = response ?? {};
        if (approvedStatus?.toLowerCase() === "approved") {
          return true;
        }
        return false;
      }
      return false;
    } catch (err: any) {
      return false;
    }
  };

  const getTokenDetails = useCallback(
    (code: string,hostType?: string) => {
      if(code){
        get(`${API_URL.EMAIL_VERIFICATION}/${qrId}/?type=qr`, hostType).then((resp) => {
          if (resp) {
            setQrDetails(resp?.data?.token ?? '')
          }
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return {
    fetchCodesForVerification,
    selectOptionFromMobile,
    mobileLinkOnDevice,
    data: loginApiData,
    statusCode,
    handleAuthUser,
    handleVerifyEmail,
    getTokenDetails,
  };
};
